import { text } from '@modules/auth/text';
import { useAuthActions } from '@convex-dev/auth/react';

import { getGuestErrorMessage } from '@modules/auth/business_logic';

export function useGuestSignIn(
  onSuccess: (message: string) => void,
  onError: (message: string) => void,
  onSuccessNavigate: () => void,
  setIsSubmitting: (isSubmitting: boolean) => void,
  resetForm: () => void
) {
  const { signIn } = useAuthActions();

  return () => {
    setIsSubmitting(true);

    signIn('anonymous')
      .then(() => {
        onSuccess(text.guestSuccess);
        resetForm();
        onSuccessNavigate();
      })
      .catch((error: Error) => {
        onError(getGuestErrorMessage(error));
        setIsSubmitting(false);
      });
  };
}
